import React from 'react';
import SupplierEsgOverview from '../modules/supplier-assessment/SupplierEsgOverview';

export default function SupplierPortalESG() {
  return <SupplierEsgOverview />;
}